var map = {
	"./generalitat.png": 89216,
	"./links_block1.png": 23836,
	"./links_block2.png": 47767,
	"./links_block3.png": 48270,
	"./logo_decidim.svg": 15232,
	"./logo_i2cat.png": 11077,
	"./logo_pokecode.svg": 72123,
	"./logo_pokecode_white.png": 53514,
	"./path34.svg": 12957,
	"./ue_logo.png": 75832,
	"./wpoauth-icon.svg": 35185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;